module.exports = __webpack_public_path__ + "img/Carla_Portela.804a1054.jpeg";